// @ts-nocheck

import { reduce, mapValues } from 'lodash';

import config from '../../config/app.config';
import { BasketModes, BasketStatuses, BasketItemStatuses } from '../../types/basket';
import { createReducer, basket as BasketUtils } from '../../utils';

import handlers from './handlers';

export const initialBasketBaseState = {
  items: {},
  freebets: {},
  bonuses: {},
  itemsMemoizedForSelection: {},
  isKeyboardVisible: false,
  eligibleKLCollectibleId: null,
  isGRActive: null,
  isMonopolyActive: false,
  isBoomActive: false,
  cachedMMAPIResponsesInfos: {},
  monopolyCard: null,
  isFromLineUp: false,
  boom: null,
};

const getBasketReducer = () => {
  const {
    basket: { defaultStake },
  } = config;

  const initialItems = {};
  const intialSystems = undefined;
  const intialMode = BasketModes.SIMPLE;
  const initialDefaultStake = defaultStake;
  let initialLoading = false;
  let intialStateOverride = null;

  // if we have saved the basket items in localstorage then we load it
  const initialStateFromStorage = BasketUtils.loadBasketFromStorage();

  if (initialStateFromStorage) {
    initialLoading = true;
    const { isCashout, ...rest } = initialStateFromStorage;
    delete rest.version;

    intialStateOverride = {
      ...rest,
      items: mapValues(initialStateFromStorage.items, (x) => ({
        ...x,
        status: BasketItemStatuses.OK,
        stake: BasketUtils.formatStake(isNaN(parseFloat(x.stake)) ? initialDefaultStake : x.stake),
        cashout: isCashout ? x.cashout : false,
      })),
      stake: isNaN(parseFloat(initialStateFromStorage.stake))
        ? ''
        : BasketUtils.formatStake(initialStateFromStorage.stake),
      isCashout,
    };
  }

  const PRELOADED_STATE = window.PRELOADED_STATE;
  if (PRELOADED_STATE !== undefined) {
    const { basket } = PRELOADED_STATE;
    if (basket !== undefined) {
      const { addItemsToBasket } = basket;
      if (addItemsToBasket !== undefined) {
        initialLoading = true;
        let increment = 0;
        intialStateOverride = {
          items: reduce(
            addItemsToBasket,
            (finalItems, { matchId, betId, oddId }) => {
              const fItemsRef = finalItems;
              if (fItemsRef[oddId] === undefined) {
                fItemsRef[oddId] = {
                  oddId,
                  betId,
                  matchId,
                  sortBy: Date.now() + increment,
                  addedFromPreloadedState: true,
                };
                increment += 1;
              }
              return fItemsRef;
            },
            {},
          ),
        };
      }
    }
  }

  const initialState = {
    ...initialBasketBaseState,
    items: initialItems,
    mode: intialMode,
    status: BasketStatuses.OK,
    defaultStake: initialDefaultStake,
    stake: '',
    systems: intialSystems,
    betslipId: undefined,
    errorMessage: undefined,
    additionalMessage: undefined,
    loading: initialLoading,
    isCashout: false,
    isKeyboardVisible: false,
    ...intialStateOverride,
  };

  return createReducer(initialState, handlers);
};

export default getBasketReducer;
